"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var style_1 = require("ol/style/Style");
var image_1 = require("ol/style/Image");
var fill_1 = require("ol/style/Fill");
var stroke_1 = require("ol/style/Stroke");
var text_1 = require("ol/style/Text");
var circle_1 = require("ol/style/Circle");
var icon_1 = require("ol/style/Icon");
var regularshape_1 = require("ol/style/RegularShape");
var OlStyleUtil_1 = require("./Util/OlStyleUtil");
var util_1 = require("util");
/**
 * This parser can be used with the GeoStyler.
 * It implements the GeoStyler-Style Parser interface to work with OpenLayers styles.
 *
 * @class OlStyleParser
 * @implements StyleParser
 */
var OlStyleParser = /** @class */ (function () {
    function OlStyleParser() {
    }
    /**
     * Get the GeoStyler-Style PointSymbolizer from an OpenLayers Style object.
     *
     * @param {object} olStyle The OpenLayers Style object
     * @return {PointSymbolizer} The GeoStyler-Style PointSymbolizer
     */
    OlStyleParser.prototype.getPointSymbolizerFromOlStyle = function (olStyle) {
        var pointSymbolizer;
        if (olStyle.getImage() instanceof circle_1.default) {
            // circle
            var olCircleStyle = olStyle.getImage();
            var olFillStyle = olCircleStyle.getFill();
            var olStrokeStyle = olCircleStyle.getStroke();
            var circleSymbolizer = {
                kind: 'Mark',
                wellKnownName: 'Circle',
                color: olFillStyle ? OlStyleUtil_1.default.getHexColor(olFillStyle.getColor()) : undefined,
                opacity: olFillStyle ? OlStyleUtil_1.default.getOpacity(olFillStyle.getColor()) : undefined,
                radius: (olCircleStyle.getRadius() !== 0) ? olCircleStyle.getRadius() : 5,
                strokeColor: olStrokeStyle ? olStrokeStyle.getColor() : undefined,
                strokeOpacity: olStrokeStyle ? OlStyleUtil_1.default.getOpacity(olStrokeStyle.getColor()) : undefined,
                strokeWidth: olStrokeStyle ? olStrokeStyle.getWidth() : undefined
            };
            pointSymbolizer = circleSymbolizer;
        }
        else if (olStyle.getImage() instanceof regularshape_1.default) {
            // square, triangle, star, cross or x
            var olRegularStyle = olStyle.getImage();
            var olFillStyle = olRegularStyle.getFill();
            var olStrokeStyle = olRegularStyle.getStroke();
            var radius = olRegularStyle.getRadius();
            var radius2 = olRegularStyle.getRadius2();
            var points = olRegularStyle.getPoints();
            var angle = olRegularStyle.getAngle();
            var markSymbolizer = {
                kind: 'Mark',
                color: olFillStyle ? OlStyleUtil_1.default.getHexColor(olFillStyle.getColor()) : undefined,
                opacity: olFillStyle ? OlStyleUtil_1.default.getOpacity(olFillStyle.getColor()) : undefined,
                strokeColor: olStrokeStyle ? olStrokeStyle.getColor() : undefined,
                strokeOpacity: olStrokeStyle ? OlStyleUtil_1.default.getOpacity(olStrokeStyle.getColor()) : undefined,
                strokeWidth: olStrokeStyle ? olStrokeStyle.getWidth() : undefined,
                radius: (radius !== 0) ? radius : 5,
                // Rotation in openlayers is radians while we use degree
                rotate: olRegularStyle.getRotation() / Math.PI * 180
            };
            switch (points) {
                case 2:
                    switch (angle) {
                        case 0:
                            markSymbolizer.wellKnownName = 'shape://vertline';
                            break;
                        case Math.PI / 2:
                            markSymbolizer.wellKnownName = 'shape://horline';
                            break;
                        case Math.PI / 4:
                            markSymbolizer.wellKnownName = 'shape://slash';
                            break;
                        case 2 * Math.PI - (Math.PI / 4):
                            markSymbolizer.wellKnownName = 'shape://backslash';
                            break;
                        default:
                            break;
                    }
                    break;
                case 3:
                    switch (angle) {
                        case 0:
                            markSymbolizer.wellKnownName = 'Triangle';
                            break;
                        case Math.PI / 2:
                            markSymbolizer.wellKnownName = 'shape://carrow';
                            break;
                        default:
                            break;
                    }
                    break;
                case 4:
                    if (util_1.isNumber(radius2)) {
                        // cross or x
                        if (olRegularStyle.getAngle() === 0) {
                            // cross
                            markSymbolizer.wellKnownName = 'Cross';
                        }
                        else {
                            // x
                            markSymbolizer.wellKnownName = 'X';
                        }
                    }
                    else {
                        // square
                        markSymbolizer.wellKnownName = 'Square';
                    }
                    break;
                case 5:
                    // star
                    markSymbolizer.wellKnownName = 'Star';
                    break;
                default:
                    throw new Error("Could not parse OlStyle. Only 2, 3, 4 or 5 point regular shapes are allowed");
            }
            pointSymbolizer = markSymbolizer;
        }
        else {
            // icon
            var olIconStyle = olStyle.getImage();
            var iconSymbolizer = {
                kind: 'Icon',
                image: olIconStyle.getSrc() ? olIconStyle.getSrc() : undefined,
                opacity: olIconStyle.getOpacity(),
                size: (olIconStyle.getScale() !== 0) ? olIconStyle.getScale() : 5,
                // Rotation in openlayers is radians while we use degree
                rotate: olIconStyle.getRotation() / Math.PI * 180
            };
            pointSymbolizer = iconSymbolizer;
        }
        return pointSymbolizer;
    };
    /**
     * Get the GeoStyler-Style LineSymbolizer from an OpenLayers Style object.
     *
     * @param {object} olStyle The OpenLayers Style object
     * @return {LineSymbolizer} The GeoStyler-Style LineSymbolizer
     */
    OlStyleParser.prototype.getLineSymbolizerFromOlStyle = function (olStyle) {
        var olStrokeStyle = olStyle.getStroke();
        return {
            kind: 'Line',
            color: olStrokeStyle ? OlStyleUtil_1.default.getHexColor(olStrokeStyle.getColor()) : undefined,
            opacity: olStrokeStyle ? OlStyleUtil_1.default.getOpacity(olStrokeStyle.getColor()) : undefined,
            width: olStrokeStyle ? olStrokeStyle.getWidth() : undefined,
            cap: olStrokeStyle ? olStrokeStyle.getLineCap() : 'butt',
            join: olStrokeStyle ? olStrokeStyle.getLineJoin() : 'miter',
            dasharray: olStrokeStyle ? olStrokeStyle.getLineDash() : undefined,
            dashOffset: olStrokeStyle ? olStrokeStyle.getLineDashOffset() : undefined
        };
    };
    /**
     * Get the GeoStyler-Style FillSymbolizer from an OpenLayers Style object.
     *
     * PolygonSymbolizer Stroke is just partially supported.
     *
     * @param {OlStyle} olStyle The OpenLayers Style object
     * @return {FillSymbolizer} The GeoStyler-Style FillSymbolizer
     */
    OlStyleParser.prototype.getFillSymbolizerFromOlStyle = function (olStyle) {
        var olFillStyle = olStyle.getFill();
        var olStrokeStyle = olStyle.getStroke();
        return {
            kind: 'Fill',
            color: olFillStyle ? OlStyleUtil_1.default.getHexColor(olFillStyle.getColor()) : undefined,
            opacity: olFillStyle ? OlStyleUtil_1.default.getOpacity(olFillStyle.getColor()) : undefined,
            outlineColor: olStrokeStyle ? olStrokeStyle.getColor() : undefined,
            outlineWidth: olStrokeStyle ? olStrokeStyle.getWidth() : undefined
        };
    };
    /**
     * Get the GeoStyler-Style TextSymbolizer from an OpenLayers Style object.
     *
     *
     * @param {OlStyle} olStyle The OpenLayers Style object
     * @return {TextSymbolizer} The GeoStyler-Style TextSymbolizer
     */
    OlStyleParser.prototype.getTextSymbolizerFromOlStyle = function (olStyle) {
        var olTextStyle = olStyle.getText();
        var olFillStyle = olTextStyle.getFill();
        var olStrokeStyle = olTextStyle.getStroke();
        var offsetX = olTextStyle.getOffsetX();
        var offsetY = olTextStyle.getOffsetY();
        var font = olTextStyle.getFont();
        var rotation = olTextStyle.getRotation();
        var text = olTextStyle.getText();
        var fontStyleWeightSize;
        var fontSizePart;
        var fontSize = Infinity;
        var fontFamily = undefined;
        if (font) {
            var fontSplit = font.split('px');
            // font-size is always the first part of font-size/line-height
            fontStyleWeightSize = fontSplit[0].trim();
            fontSizePart = fontStyleWeightSize.split(' ');
            // The last element contains font size
            fontSize = parseInt(fontSizePart[fontSizePart.length - 1], 10);
            var fontFamilyPart = fontSplit.length === 2 ?
                fontSplit[1] : fontSplit[2];
            fontFamily = fontFamilyPart.split(',').map(function (fn) {
                return fn.startsWith(' ') ? fn.slice(1) : fn;
            });
        }
        return {
            kind: 'Text',
            label: text,
            color: olFillStyle ? OlStyleUtil_1.default.getHexColor(olFillStyle.getColor()) : undefined,
            size: isFinite(fontSize) ? fontSize : undefined,
            font: fontFamily,
            offset: (offsetX !== undefined) && (offsetY !== undefined) ? [offsetX, offsetY] : [0, 0],
            haloColor: olStrokeStyle && olStrokeStyle.getColor() ?
                OlStyleUtil_1.default.getHexColor(olStrokeStyle.getColor()) : undefined,
            haloWidth: olStrokeStyle ? olStrokeStyle.getWidth() : undefined,
            rotate: (rotation !== undefined) ? rotation / Math.PI * 180 : undefined
        };
    };
    /**
     * Get the GeoStyler-Style Symbolizer from an OpenLayers Style object.
     *
     * @param {OlStyle} olStyle The OpenLayers Style object
     * @return {Symbolizer[]} The GeoStyler-Style Symbolizer array
     */
    OlStyleParser.prototype.getSymbolizersFromOlStyle = function (olStyles) {
        var _this = this;
        var symbolizers = [];
        olStyles.forEach(function (olStyle) {
            var symbolizer;
            var styleType = _this.getStyleTypeFromOlStyle(olStyle);
            switch (styleType) {
                case 'Point':
                    if (olStyle.getText()) {
                        symbolizer = _this.getTextSymbolizerFromOlStyle(olStyle);
                    }
                    else {
                        symbolizer = _this.getPointSymbolizerFromOlStyle(olStyle);
                    }
                    break;
                case 'Line':
                    symbolizer = _this.getLineSymbolizerFromOlStyle(olStyle);
                    break;
                case 'Fill':
                    symbolizer = _this.getFillSymbolizerFromOlStyle(olStyle);
                    break;
                default:
                    throw new Error('Failed to parse SymbolizerKind from OpenLayers Style');
            }
            symbolizers.push(symbolizer);
        });
        return symbolizers;
    };
    /**
     * Get the GeoStyler-Style Rule from an OpenLayers Style object.
     *
     * @param {OlStyle} olStyle The OpenLayers Style object
     * @return {Rule} The GeoStyler-Style Rule
     */
    OlStyleParser.prototype.getRulesFromOlStyle = function (olStyles) {
        var _this = this;
        var rules = [];
        olStyles.forEach(function (olRule, idx) {
            var symbolizers = _this.getSymbolizersFromOlStyle(olRule);
            var name = 'OL Style Rule ' + idx;
            rules.push({
                name: name, symbolizers: symbolizers
            });
        });
        return rules;
    };
    /**
     * Get the GeoStyler-Style Symbolizer from an OpenLayers Style object.
     *
     * @param {OlStyle} olStyle The OpenLayers Style object
     * @return {Symbolizer} The GeoStyler-Style Symbolizer
     */
    OlStyleParser.prototype.getStyleTypeFromOlStyle = function (olStyle) {
        var styleType;
        if (olStyle.getImage() instanceof image_1.default) {
            styleType = 'Point';
        }
        else if (olStyle.getText() instanceof text_1.default) {
            styleType = 'Point';
        }
        else if (olStyle.getFill() instanceof fill_1.default) {
            styleType = 'Fill';
        }
        else if (olStyle.getStroke() && !olStyle.getFill()) {
            styleType = 'Line';
        }
        else {
            throw new Error('StyleType could not be detected');
        }
        return styleType;
    };
    /**
     * Get the GeoStyler-Style Style from an OpenLayers Style object.
     *
     * @param {object} olStyle The OpenLayers Style object
     * @return {Style} The GeoStyler-Style Style
     */
    OlStyleParser.prototype.olStyleToGeoStylerStyle = function (olStyle) {
        var name = 'OL Style';
        var rules = this.getRulesFromOlStyle(olStyle);
        return {
            name: name,
            rules: rules
        };
    };
    /**
     * The readStyle implementation of the GeoStyler-Style StyleParser interface.
     * It reads a nested array of OpenLayers style instances and returns a Promise.
     * Each element in the first dimension of the OlStyle array defines a rule, each element
     * in the second dimension defines a symbolizer within that rule.
     * The Promise itself resolves with a GeoStyler-Style Style.
     *
     * @param {OlStyle[][]} olStyle A nested array of OpenLayers style instances
     * @return {Promise} The Promise resolving with the GeoStyler-Style Style
     */
    OlStyleParser.prototype.readStyle = function (olStyle) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var geoStylerStyle = _this.olStyleToGeoStylerStyle(olStyle);
                resolve(geoStylerStyle);
            }
            catch (error) {
                reject(error);
            }
        });
    };
    /**
     * The writeStyle implementation of the GeoStyler-Style StyleParser interface.
     * It reads a GeoStyler-Style Style and returns a Promise.
     * The Promise itself resolves with a nested array of OpenLayers style objects.
     * Each element in the first dimension of the OlStyle array defines a rule, each element
     * in the second dimension defines a symbolizer within that rule.
     *
     * @param {Style} geoStylerStyle A GeoStyler-Style Style.
     * @return {Promise} The Promise resolving with a nested array of OpenLayers style instance.
     */
    OlStyleParser.prototype.writeStyle = function (geoStylerStyle) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var olStyles = _this.geoStylerStyleToOlStyle(geoStylerStyle);
				for (var o in olStyles[0]) {
					olStyles[0][o].getImage = function () {
						return this.image_;
					};
				}
                resolve(olStyles);
            }
            catch (error) {
                reject(error);
            }
        });
    };
    /**
     * Get the OpenLayers Style object from an GeoStyler-Style Style
     *
     * @param {Style} geoStylerStyle A GeoStyler-Style Style.
     * @return {OlStyle[][]} A nested array containing OpenLayers style instance(s)
     */
    OlStyleParser.prototype.geoStylerStyleToOlStyle = function (geoStylerStyle) {
        var _this = this;
        var rules = geoStylerStyle.rules;
        var symbArr = [];
        rules.forEach(function (rule) {
            var ruleSymbs = [];
            rule.symbolizers.forEach(function (symb) {
                ruleSymbs.push(_this.getOlSymbolizerFromSymbolizer(symb));
            });
            symbArr.push(ruleSymbs);
        });
        return symbArr;
    };
    /**
     * Get the OpenLayers Style object or an OL StyleFunction from an
     * GeoStyler-Style Symbolizer.
     *
     * @param {Symbolizer} symbolizer A GeoStyler-Style Symbolizer.
     * @return {object} The OpenLayers Style object or a StyleFunction
     */
    OlStyleParser.prototype.getOlSymbolizerFromSymbolizer = function (symbolizer) {
        var olSymbolizer;
        switch (symbolizer.kind) {
            case 'Mark':
                olSymbolizer = this.getOlPointSymbolizerFromMarkSymbolizer(symbolizer);
                break;
            case 'Icon':
                olSymbolizer = this.getOlIconSymbolizerFromIconSymbolizer(symbolizer);
                break;
            case 'Text':
                olSymbolizer = this.getOlTextSymbolizerFromTextSymbolizer(symbolizer);
                break;
            case 'Line':
                olSymbolizer = this.getOlLineSymbolizerFromLineSymbolizer(symbolizer);
                break;
            case 'Fill':
                olSymbolizer = this.getOlPolygonSymbolizerFromFillSymbolizer(symbolizer);
                break;
            default:
                // Return the OL default style since the TS type binding does not allow
                // us to set olSymbolizer to undefined
                var fill = new fill_1.default({
                    color: 'rgba(255,255,255,0.4)'
                });
                var stroke = new stroke_1.default({
                    color: '#3399CC',
                    width: 1.25
                });
                olSymbolizer = new style_1.default({
                    image: new circle_1.default({
                        fill: fill,
                        stroke: stroke,
                        radius: 5
                    }),
                    fill: fill,
                    stroke: stroke
                });
                break;
        }
        return olSymbolizer;
    };
    /**
      * Get the OL Style object  from an GeoStyler-Style MarkSymbolizer.
      *
      * @param {MarkSymbolizer} markSymbolizer A GeoStyler-Style MarkSymbolizer.
      * @return {object} The OL Style object
      */
    OlStyleParser.prototype.getOlPointSymbolizerFromMarkSymbolizer = function (markSymbolizer) {
        var stroke;
        if (markSymbolizer.strokeColor || markSymbolizer.strokeWidth !== undefined) {
            stroke = new stroke_1.default({
                color: (markSymbolizer.strokeColor && (markSymbolizer.strokeOpacity !== undefined)) ?
                    OlStyleUtil_1.default.getRgbaColor(markSymbolizer.strokeColor, markSymbolizer.strokeOpacity) :
                    markSymbolizer.strokeColor,
                width: markSymbolizer.strokeWidth,
            });
        }
        var fill = new fill_1.default({
            color: (markSymbolizer.color && markSymbolizer.opacity !== undefined) ?
                OlStyleUtil_1.default.getRgbaColor(markSymbolizer.color, markSymbolizer.opacity) : markSymbolizer.color
        });
        var olStyle;
        var shapeOpts = {
            fill: fill,
            opacity: markSymbolizer.opacity || 1,
            radius: markSymbolizer.radius || 5,
            rotation: markSymbolizer.rotate ? markSymbolizer.rotate * Math.PI / 180 : undefined,
            stroke: stroke
        };
        switch (markSymbolizer.wellKnownName) {
            case 'shape://dot':
                shapeOpts.radius = 1;
                olStyle = new style_1.default({
                    image: new circle_1.default(shapeOpts)
                });
            case 'Circle':
                olStyle = new style_1.default({
                    image: new circle_1.default(shapeOpts)
                });
                break;
            case 'Line':
                olStyle = new style_1.default(shapeOpts);
                break;
            case 'Square':
                shapeOpts.points = 4;
                shapeOpts.angle = 45 * Math.PI / 180;
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'Triangle':
                shapeOpts.points = 3;
                shapeOpts.angle = 0;
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'Star':
                shapeOpts.points = 5;
                shapeOpts.radius2 = shapeOpts.radius / 2.5;
                shapeOpts.angle = 0;
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'shape://plus':
            case 'Cross':
                shapeOpts.points = 4;
                shapeOpts.radius2 = 0;
                shapeOpts.angle = 0;
                // openlayers does not seem to set a default stroke color,
                // which is needed for regularshapes with radius2 = 0
                if (shapeOpts.stroke === undefined) {
                    shapeOpts.stroke = new stroke_1.default({
                        color: '#000'
                    });
                }
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'shape://times':
            case 'X':
                shapeOpts.points = 4;
                shapeOpts.radius2 = 0;
                shapeOpts.angle = 45 * Math.PI / 180;
                // openlayers does not seem to set a default stroke color,
                // which is needed for regularshapes with radius2 = 0
                if (shapeOpts.stroke === undefined) {
                    shapeOpts.stroke = new stroke_1.default({
                        color: '#000'
                    });
                }
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'shape://backslash':
                shapeOpts.points = 2;
                shapeOpts.angle = 2 * Math.PI - (Math.PI / 4);
                // openlayers does not seem to set a default stroke color,
                // which is needed for regularshapes with radius2 = 0
                if (shapeOpts.stroke === undefined) {
                    shapeOpts.stroke = new stroke_1.default({
                        color: '#000'
                    });
                }
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'shape://horline':
                shapeOpts.points = 2;
                shapeOpts.angle = Math.PI / 2;
                // openlayers does not seem to set a default stroke color,
                // which is needed for regularshapes with radius2 = 0
                if (shapeOpts.stroke === undefined) {
                    shapeOpts.stroke = new stroke_1.default({
                        color: '#000'
                    });
                }
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            // so far, both arrows are closed arrows. Also, shape is a regular triangle with
            // all sides of equal length. In geoserver arrows only have two sides of equal length.
            // TODO redefine shapes of arrows?
            case 'shape://oarrow':
            case 'shape://carrow':
                shapeOpts.points = 3;
                shapeOpts.angle = Math.PI / 2;
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'Filled_arrowhead':
                shapeOpts.points = 3;
                shapeOpts.angle = Math.PI / 2;
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'shape://slash':
                shapeOpts.points = 2;
                shapeOpts.angle = Math.PI / 4;
                // openlayers does not seem to set a default stroke color,
                // which is needed for regularshapes with radius2 = 0
                if (shapeOpts.stroke === undefined) {
                    shapeOpts.stroke = new stroke_1.default({
                        color: '#000'
                    });
                }
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            case 'shape://vertline':
                shapeOpts.points = 2;
                shapeOpts.angle = 0;
                // openlayers does not seem to set a default stroke color,
                // which is needed for regularshapes with radius2 = 0
                if (shapeOpts.stroke === undefined) {
                    shapeOpts.stroke = new stroke_1.default({
                        color: '#000'
                    });
                }
                olStyle = new style_1.default({
                    image: new regularshape_1.default(shapeOpts)
                });
                break;
            default:
                throw new Error("MarkSymbolizer cannot be parsed. Unsupported WellKnownName.");
        }
        return olStyle;
    };

    /**
     * Get the OL Style object  from an GeoStyler-Style IconSymbolizer.
     *
     * @param {IconSymbolizer} symbolizer  A GeoStyler-Style IconSymbolizer.
     * @return {object} The OL Style object
     */
    OlStyleParser.prototype.getOlIconSymbolizerFromIconSymbolizer = function (symbolizer) {
        return new style_1.default({
            image: new icon_1.default({
                src: symbolizer.image,
                crossOrigin: 'anonymous',
                opacity: symbolizer.opacity,
                scale: symbolizer.size || 1,
                // Rotation in openlayers is radians while we use degree
                rotation: symbolizer.rotate ? symbolizer.rotate * Math.PI / 180 : undefined
            })
        });
    };
    /**
     * Get the OL Style object from an GeoStyler-Style LineSymbolizer.
     *
     * @param {LineSymbolizer} lineSymbolizer A GeoStyler-Style LineSymbolizer.
     * @return {object} The OL Style object
     */
    OlStyleParser.prototype.getOlLineSymbolizerFromLineSymbolizer = function (symbolizer) {
        return new style_1.default({
            stroke: new stroke_1.default({
                color: (symbolizer.color && symbolizer.opacity) ?
                    OlStyleUtil_1.default.getRgbaColor(symbolizer.color, symbolizer.opacity) : symbolizer.color,
                width: symbolizer.width,
                lineCap: symbolizer.cap,
                lineJoin: symbolizer.join,
                lineDash: symbolizer.dasharray,
                lineDashOffset: symbolizer.dashOffset
            })
        });
    };
    /**
         * Get the OL Style object from an GeoStyler-Style FillSymbolizer.
         *
         * @param {FillSymbolizer} fillSymbolizer A GeoStyler-Style FillSymbolizer.
         * @return {object} The OL Style object
         */
    OlStyleParser.prototype.getOlPolygonSymbolizerFromFillSymbolizer = function (symbolizer) {
        return new style_1.default({
            stroke: !symbolizer.outlineColor && !symbolizer.outlineWidth ? undefined : new stroke_1.default({
                color: symbolizer.outlineColor,
                width: symbolizer.outlineWidth
            }),
            fill: new fill_1.default({
                color: (symbolizer.color && symbolizer.opacity) ?
                    OlStyleUtil_1.default.getRgbaColor(symbolizer.color, symbolizer.opacity) : symbolizer.color
            })
        });
    };

    /**
     * Get the OL StyleFunction object from an GeoStyler-Style TextSymbolizer.
     *
     * @param {TextSymbolizer} textSymbolizer A GeoStyler-Style TextSymbolizer.
     * @return {object} The OL StyleFunction
     */
    OlStyleParser.prototype.getOlTextSymbolizerFromTextSymbolizer = function (symbolizer) {
        var baseProps = {
            font: OlStyleUtil_1.default.getTextFont(symbolizer),
            fill: new fill_1.default({
                color: (symbolizer.color && symbolizer.opacity) ?
                    OlStyleUtil_1.default.getRgbaColor(symbolizer.color, symbolizer.opacity) : symbolizer.color
            }),
            stroke: new stroke_1.default({
                color: (symbolizer.haloColor && symbolizer.opacity) ?
                    OlStyleUtil_1.default.getRgbaColor(symbolizer.haloColor, symbolizer.opacity) : symbolizer.haloColor,
                width: symbolizer.haloWidth ? symbolizer.haloWidth : 0
            }),
            offsetX: symbolizer.offset ? symbolizer.offset[0] : 0,
            offsetY: symbolizer.offset ? symbolizer.offset[1] : 0,
            rotation: symbolizer.rotate ? symbolizer.rotate * Math.PI / 180 : undefined
            // TODO check why props match
            // textAlign: symbolizer.pitchAlignment,
            // textBaseline: symbolizer.anchor
        };
        // check if TextSymbolizer.label contains a placeholder
        var prefix = '\\{\\{';
        var suffix = '\\}\\}';
        var regExp = new RegExp(prefix + '.*?' + suffix, 'g');
        var regExpRes = symbolizer.label ? symbolizer.label.match(regExp) : null;
        if (regExpRes) {
            // if it contains a placeholder
            // return olStyleFunction
            var olPointStyledLabelFn = function (feature, res) {
                var text = new text_1.default(__assign({ text: OlStyleUtil_1.default.resolveAttributeTemplate(feature, symbolizer.label, '') }, baseProps));
                var style = new style_1.default({
                    text: text
                });
                return style;
            };
            return olPointStyledLabelFn;
        }
        else {
            // if TextSymbolizer does not contain a placeholder
            // return OlStyle
            return new style_1.default({
                text: new text_1.default(__assign({ text: symbolizer.label }, baseProps))
            });
        }
    };
    /**
     * The name of the OlStyleParser.
     */
    OlStyleParser.title = 'OpenLayers Style Parser';
    return OlStyleParser;
}());
exports.default = OlStyleParser;
//# sourceMappingURL=OlStyleParser.js.map